import axios from '../request/http';


const PlatformPartner = {
  //合伙人信息列表
  partnerList(params) {
    return axios.get("/admin/partner/list", {
      params
    });
  },
  //合伙人订单列表
  partnerOrderList(params) {
    return axios.get("/admin/partner/order/list", {
      params
    });
  },
  //合伙人订单分佣明细
  partnerRevenueDetail(params) {
    return axios.get("/admin/partner/revenue/detail", {
      params
    });
  },
  //合伙人修改上级
  partnerUpdateBinding(params) {
    return axios.get("/admin/partner/update/binding", {
      params
    });
  },
  //修改合伙人身份
  partnerUpdateLevel(params) {
    return axios.get("/admin/partner/update/level", {
      params
    });
  },
  //查看分佣明细
  partnerRevenueDetail(params) {
    return axios.get("/admin/partner/revenue/detail", {
      params
    });
  },
  //修改合伙人股票
  partnerUpdateTicket(params) {
    return axios.get("/admin/partner/update/ticket", {
      params
    });
  },
  //合伙人统计
  partnerStatistics(params) {
    return axios.get("/admin/partner/info/statistic", {
      params
    });
  },
  // 新建合伙人
  addPartner(params) {
    return axios.get("/admin/partner/add/partner", {
      params
    });
  },
  // 合伙人开通店铺
  partnerOpenShop(params) {
    return axios.get("/admin/partner/open/shop", {
      params
    });
  },
  // 合伙人记录列表 
  partnerTicketList(params) {
    return axios.get("/admin/partner/ticket/list", {
      params
    });
  },
  // 合伙人架构图
  partnerTreeMap(params) {
    return axios.get("/admin/partner/tree/map", {
      params
    });
  },
  // 查看合伙人详情
  partnerDetail(params) {
    return axios.get("/admin/partner/detail/info", {
      params
    });
  },
  // 合伙人信息搜索列表
  partnerSearchList(params) {
    return axios.get("/admin/partner/search/list", {
      params
    });
  },
  // 合伙人信息搜索列表
  partnerOnoff(params) {
    return axios.get("/admin/partner/bonus/on-off", {
      params
    });
  },
  // 查看提现明细接口
  partnercashList(params) {
    return axios.get("/admin/partner/cash/list", {
      params
    });
  },
  // 合伙人上周奖励发放明细
  partnerweekDetail(params) {
    return axios.get("/admin/partner/bonus/week/detail", {
      params
    });
  },
  //合伙人个人收益排行榜
  partnebonusRank(params) {
    return axios.get("/admin/partner/bonus/rank", {
      params
    });
  },
  //合伙人奖金发放预估
  partnebonusEstimate(params) {
    return axios.get("/admin/partner/bonus/estimate", {
      params
    });
  },
  // 合伙人奖金发放预估
  partnebonusIssue(params) {
    return axios.get("/admin/partner/bonus/issue", {
      params
    });
  },
    // 合伙人每周收益图
  partnebonusWeek(params) {
    return axios.get("/admin/partner/bonus/week", {
      params
    });
  },
      // 合伙人上级更换记录列表
  partnechangeList(params) {
    return axios.get("/admin/partner/superior/change/list", {
      params
    });
  },

}

export default PlatformPartner;



// WEBPACK FOOTER //
// ./src/api/PlatformPartner.js